<template>
  <aside class="aside-menu" :class="{ open: $store.state.openBurgerMenu === true }">
    <div class="aside-menu__wrapper">
      <div class="aside-menu__wrapper-header">
        <h1>Control panel</h1>
        <div
          class="aside-menu__wrapper-header__img"
          :class="{
            'rbxtree-bg': $store.state.toggleSite === 'rbxpier'
          }"
          @click="toggleSite"
        >
          <img v-if="$store.state.toggleSite === 'rbxtree'" src="../../assets/images/asideMenu/rbxpier.svg" />
          <img src="../../assets/images/home/rbx-tree.svg" v-else alt="" />
        </div>
      </div>
      <div class="aside-menu__wrapper-content">
        <ul v-if="$store.state.toggleSite === 'rbxtree'">
          <li
            :class="{
              'active-link ': $store.state.currentTub.rbxtree === 'topups'
            }"
            @click="
              $store.state.currentTub.rbxtree = 'topups';
              $store.state.openBurgerMenu = false;
            "
          >
            TOPUPS
          </li>
          <li
            @click="
              $store.state.currentTub.rbxtree = 'transfer';
              $store.state.openBurgerMenu = false;
            "
            :class="{
              'active-link ': $store.state.currentTub.rbxtree === 'transfer'
            }"
          >
            TRANSFER
          </li>
          <li
            @click="
              $store.state.currentTub.rbxtree = 'gift';
              $store.state.openBurgerMenu = false;
            "
            :class="{
              'active-link ': $store.state.currentTub.rbxtree === 'gift'
            }"
          >
            GIFT
          </li>
          <li
            @click="
              $store.state.currentTub.rbxtree = 'superPass';
              $store.state.openBurgerMenu = false;
            "
            :class="{
              'active-link ': $store.state.currentTub.rbxtree === 'superPass'
            }"
          >
            SUPER PASS
          </li>
          <li
            @click="
              $store.state.currentTub.rbxtree = 'logpass';
              $store.state.openBurgerMenu = false;
            "
            :class="{
              'active-link ': $store.state.currentTub.rbxtree === 'logpass'
            }"
          >
            LogPass
          </li>
          <li
            @click="
              $store.state.currentTub.rbxtree = 'steam';
              $store.state.openBurgerMenu = false;
            "
            :class="{
              'active-link ': $store.state.currentTub.rbxtree === 'steam'
            }"
          >
            STEAM
          </li>
          <li
            @click="
              $store.state.currentTub.rbxtree = 'tgStars';
              $store.state.openBurgerMenu = false;
            "
            :class="{
              'active-link ': $store.state.currentTub.rbxtree === 'tgStars'
            }"
          >
            TG STARS
          </li>
          <li
            @click="
              $store.state.currentTub.rbxtree = 'tgPremium';
              $store.state.openBurgerMenu = false;
            "
            :class="{
              'active-link ': $store.state.currentTub.rbxtree === 'tgPremium'
            }"
          >
            TG PREMIUM
          </li>
          <li
            @click="
              $store.state.currentTub.rbxtree = 'pubg';
              $store.state.openBurgerMenu = false;
            "
            :class="{
              'active-link ': $store.state.currentTub.rbxtree === 'pubg'
            }"
          >
            PUBG MOBILE
          </li>
          <li
            @click="
              $store.state.currentTub.rbxtree = 'genshin';
              $store.state.openBurgerMenu = false;
            "
            :class="{
              'active-link ': $store.state.currentTub.rbxtree === 'genshin'
            }"
          >
            GENSHIN
          </li>
          <li
            @click="
              $store.state.currentTub.rbxtree = 'platformKeys';
              $store.state.openBurgerMenu = false;
            "
            :class="{
              'active-link ': $store.state.currentTub.rbxtree === 'platformKeys'
            }"
          >
            PLATFORM KEYS
          </li>
          <li
            @click="
              $store.state.currentTub.rbxtree = 'supercell';
              $store.state.openBurgerMenu = false;
            "
            :class="{
              'active-link ': $store.state.currentTub.rbxtree === 'supercell'
            }"
          >
            SUPERCELL
          </li>
          <li
            @click="
              $store.state.currentTub.rbxtree = 'callOfDuty';
              $store.state.openBurgerMenu = false;
            "
            :class="{
              'active-link ': $store.state.currentTub.rbxtree === 'callOfDuty'
            }"
          >
            CALL OF DUTY
          </li>
          <!--          <li
            @click="
              $store.state.currentTub.rbxtree = 'logpass';
              $store.state.openBurgerMenu = false;
            "
            :class="{
              'active-link ': $store.state.currentTub.rbxtree === 'logpass',
            }"
          >
            LOG+PASS
          </li>
          <li
            @click="
              $store.state.currentTub.rbxtree = 'premium';
              $store.state.openBurgerMenu = false;
            "
            :class="{
              'active-link ': $store.state.currentTub.rbxtree === 'premium',
            }"
          >
            PREMIUM
          </li>-->
        </ul>
        <ul v-else>
          <li
            :class="{
              'active-link-pier': $store.state.currentTub.rbxpier === 'topups'
            }"
            @click="
              $store.state.currentTub.rbxpier = 'topups';
              $store.state.openBurgerMenu = false;
            "
          >
            TOPUPS
          </li>
          <li
            :class="{
              'active-link-pier': $store.state.currentTub.rbxpier === 'transfer'
            }"
            @click="
              $store.state.currentTub.rbxpier = 'transfer';
              $store.state.openBurgerMenu = false;
            "
          >
            TRANSFER
          </li>
          <li
            @click="
              $store.state.currentTub.rbxpier = 'gift';
              $store.state.openBurgerMenu = false;
            "
            :class="{
              'active-link-pier ': $store.state.currentTub.rbxpier === 'gift'
            }"
          >
            GIFT
          </li>
          <li
            @click="
              $store.state.currentTub.rbxpier = 'superPass';
              $store.state.openBurgerMenu = false;
            "
            :class="{
              'active-link-pier ': $store.state.currentTub.rbxpier === 'superPass'
            }"
          >
            SUPER PASS
          </li>
        </ul>
      </div>
      <div
        class="exit"
        @click="
          $store.state.openBurgerMenu = false;
          $store.state.isOpenExitPopup = true;
        "
      >
        <img src="../../assets/images/asideMenu/exit.svg" alt="" />
        <p>EXIT</p>
      </div>
    </div>
  </aside>
</template>

<script>
import "./asideMenu.scss";

export default {
  name: "AsideMenu",
  data() {
    return {
      // rbxtree: {
      //   tab: "topups",
      // },
      // rbxpier: {
      //   tab: "topups",
      // },
    };
  },
  methods: {
    toggleSite() {
      this.$store.state.toggleSite === "rbxtree"
        ? (this.$store.state.toggleSite = "rbxpier")
        : (this.$store.state.toggleSite = "rbxtree");

      this.$store.state.openBurgerMenu = false;
    }
  }
};
</script>
